import { useForm, ValidationError } from "@formspree/react";
import { FiCheckCircle, FiSend } from "react-icons/fi";

import { SOCIAL_ICONS } from "../components/layout/nav";
import Card from "../components/ui/Card";
import { profile } from "../data/profile";

const ContactPage = () => {
  const [state, handleSubmit] = useForm(profile.contactFormId);

  return (
    <div className="page contact-page">
      <div className="page-head">
        <h1 className="page-title">Get In Touch</h1>
        <span className="page-sub">
          Have a question or an opportunity? Drop a message.
        </span>
      </div>

      <div className="contact-grid">
        <Card title="Send a message" className="contact-form-card">
          {state.succeeded ? (
            <div className="contact-success">
              <FiCheckCircle />
              <p>Thanks! I&apos;ll get back to you soon.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="contact-form">
              <label className="field">
                <span>Name</span>
                <input id="name" type="text" name="name" placeholder="Your name" />
              </label>

              <label className="field">
                <span>Email</span>
                <input
                  id="email"
                  type="email"
                  name="email"
                  placeholder="you@example.com"
                  required
                />
                <ValidationError prefix="Email" field="email" errors={state.errors} />
              </label>

              <label className="field">
                <span>Message</span>
                <textarea
                  id="message"
                  name="message"
                  rows={5}
                  placeholder="Hello RK! How are you?"
                  required
                />
                <ValidationError
                  prefix="Message"
                  field="message"
                  errors={state.errors}
                />
              </label>

              <button
                type="submit"
                className="lc-btn lc-btn-primary"
                disabled={state.submitting}
              >
                <FiSend /> {state.submitting ? "Sending…" : "Submit"}
              </button>
            </form>
          )}
        </Card>

        <Card title="Connect" className="contact-info-card">
          <p className="contact-intro">
            I&apos;m {profile.title} @ {profile.company}, based in{" "}
            {profile.location}. You can reach me on any of these platforms.
          </p>
          <ul className="contact-socials">
            {profile.socials.map((s) => {
              const Icon = SOCIAL_ICONS[s.id];
              return (
                <li key={s.id}>
                  <a href={s.url} target="_blank" rel="noreferrer">
                    <span className="contact-social-icon">
                      {Icon && <Icon />}
                    </span>
                    <span className="contact-social-label">{s.label}</span>
                    <span className="contact-social-handle">
                      @{s.username}
                    </span>
                  </a>
                </li>
              );
            })}
          </ul>
        </Card>
      </div>
    </div>
  );
};

export default ContactPage;
